import { __rest } from "tslib";
import * as React from 'react';
const ChevronUpLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 32 32", fill: "currentColor", width: size || "32", height: size || "32" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M15.9896061,11 L15.993,11.004 L15.9962597,11.0011284 L16.7033665,11.7082352 L16.7,11.711 L25.9950092,21.0029133 L25.2879024,21.7100201 L15.993,12.418 L6.70710678,21.7100201 L6,21.0029133 L15.286,11.711 L15.2824993,11.7071068 L15.9896061,11 Z" })));
};
ChevronUpLarge.displayName = 'ChevronUpLarge';
export default ChevronUpLarge;
//# sourceMappingURL=ChevronUpLarge.js.map